<template functional>
  <span
    :aria-hidden="props.decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    v-bind="data.attrs"
    class="material-design-icon access-point-off-icon"
    style="justify-content: center; align-items: center;"
    role="img"
    v-on="listeners">
    <svg
      :fill="props.fillColor"
      :width="props.size"
      :height="props.size"
      class="material-design-icon__svg"
      viewBox="0 0 60 59">
      <path
        d="M16.5446 26.4948C20.0664 33.3914 25.7403 39.0208 32.6615 42.5544L38.0419 37.1931C38.7022 36.5351 39.6805 36.3158 40.5364 36.6082C43.2756 37.5099 46.2348 37.9973 49.2674 37.9973C50.6125 37.9973 51.7131 39.0939 51.7131 40.4343V48.9393C51.7131 50.2797 50.6125 51.3763 49.2674 51.3763C26.3028 51.3763 7.69141 32.8309 7.69141 9.94772C7.69141 8.60738 8.79195 7.51074 10.1371 7.51074H18.6968C20.0419 7.51074 21.1425 8.60738 21.1425 9.94772C21.1425 12.9939 21.6316 15.9183 22.5365 18.6477C22.8055 19.5007 22.6099 20.4511 21.9251 21.1334L16.5446 26.4948Z"
      />
    </svg>
  </span>
</template>


<script>
export default {
  name: "Phone",
  props: {
    title: {
      type: String,
      default: ""
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "#F8F8F8"
    },
    size: {
      type: [Number, String],
      default: 32
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/icons/Phone.vue